import React from 'react';
import homestyles from '../../style/Home.module.css';
import { ArrowRightAlt } from '../atoms/Icons';
import GradientLine from '../atoms/GradientLine';
import styles from '../../style/Common.module.css';

const AboutUsSection = () => {
  return (
    <section className='pt-5 pb-5 before-bg-type1'>
        <div className=''>
            <div className='row align-items-center'>
                <div className='col-lg-6'>
                  <div className={`${homestyles.aboutImg} mb-3`}><img src='images/about-img1.webp' width='100%' alt="shivalik image" loading="lazy" decoding="async" /></div>  
                </div>
                <div className='col-lg-6'>
                    <div className={homestyles.aboutText}>
                        {/* <span className={styles.gradientLine}></span> */}
                        <GradientLine />
                        <h3 className={styles.sectionTitle}>Creating Homes, Enriching Lives</h3>
                        <p className='pb-5'>It all began in the early 80s, when two socially conscious gentlemen, Ramakant R. Jadhav and Prakash V. Ajgaonkar, rose to meet the challenge of creating quality housing for Mumbai’s lower and middle-class families</p>
                        <a className={styles.commonBlueButton} href='about-us'>Learn more <ArrowRightAlt /></a>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default AboutUsSection
